import React, { useEffect, useState } from 'react'
import LineChart from './LineChart'
import { useDispatch, useSelector } from 'react-redux'
import { getChannelChartDataAction } from 'store/action/settingsReducer'
import { VideoImage } from 'assets'

function SentimentChart() {
   const settingData = useSelector((state) => state.settings)
   const { loading, channelDetails, channelChartData } = settingData
   const authData = useSelector((state) => state.user)
   const { isDashboard } = authData
   const [isActiveDate, setIsActiveDate] = useState('day')
   const dispatch = useDispatch()

   useEffect(() => {
      if (channelDetails && channelDetails?.channel_id && !isDashboard) {
         dispatch(
            getChannelChartDataAction({
               channel_id: channelDetails?.channel_id,
               period_type: isActiveDate
            })
         )
      }
      return () => {}
   }, [channelDetails, isActiveDate])

   return (
      <div className="dashboard-chart-bg">
         <div className="card">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
               <div>
                  <p className="at-text-dark at-font-20">Sentiment Score Over Time</p>
                  <p className="at-text-light mt-2 at-font-14">
                     Tracks changes over a specific period
                  </p>
               </div>
               <div className="filter-section">
                  <div className="date-filter me-3 ">
                     <div
                        className={`month-title-wrap ${isActiveDate === 'day' ? 'active' : ''} `}
                        onClick={() => {
                           setIsActiveDate('day')
                        }}>
                        D
                     </div>
                     <div
                        className={`month-title-wrap ${isActiveDate === 'week' ? 'active' : ''} `}
                        onClick={() => {
                           setIsActiveDate('week')
                        }}>
                        W
                     </div>
                     <div
                        className={`month-title-wrap ${isActiveDate === 'month' ? 'active' : ''} `}
                        onClick={() => {
                           setIsActiveDate('month')
                        }}>
                        M
                     </div>
                  </div>
               </div>
            </div>

            <div>{channelChartData && <LineChart isActiveDate={isActiveDate} />}</div>
            {/* <div className="video-line-chart-tooltip">
               <div className="video-image-section">
                  <img src={VideoImage} className="VideoImage" />
                  <div className="v-icon">
                     <div className="video-show-emotion  v-line-chart">
                        <div className="text-wrapper" title="Sentiment">
                           <div className="text-wrapper-video-icon">
                              <svg
                                 width="16"
                                 height="16"
                                 viewBox="0 0 16 16"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                 <path
                                    d="M8 0.6875C6.55373 0.6875 5.13993 1.11637 3.9374 1.91988C2.73486 2.72339 1.7976 3.86544 1.24413 5.20163C0.690668 6.53781 0.545857 8.00811 0.828011 9.4266C1.11017 10.8451 1.80661 12.148 2.82928 13.1707C3.85196 14.1934 5.15492 14.8898 6.57341 15.172C7.99189 15.4541 9.46219 15.3093 10.7984 14.7559C12.1346 14.2024 13.2766 13.2651 14.0801 12.0626C14.8836 10.8601 15.3125 9.44628 15.3125 8C15.3105 6.06123 14.5394 4.20246 13.1685 2.83154C11.7975 1.46063 9.93877 0.689547 8 0.6875ZM5.46875 5.75C5.63563 5.75 5.79876 5.79948 5.93752 5.8922C6.07627 5.98491 6.18442 6.11669 6.24828 6.27086C6.31214 6.42504 6.32885 6.59469 6.29629 6.75836C6.26373 6.92203 6.18338 7.07237 6.06537 7.19037C5.94737 7.30837 5.79703 7.38873 5.63336 7.42129C5.46969 7.45384 5.30004 7.43713 5.14586 7.37327C4.99169 7.30941 4.85991 7.20127 4.7672 7.06251C4.67449 6.92376 4.625 6.76063 4.625 6.59375C4.625 6.36997 4.7139 6.15536 4.87213 5.99713C5.03037 5.83889 5.24498 5.75 5.46875 5.75ZM11.2991 9.96875C10.5756 11.2196 9.37321 11.9375 8 11.9375C6.6268 11.9375 5.42446 11.2203 4.70094 9.96875C4.66024 9.90473 4.63291 9.83313 4.6206 9.75828C4.60829 9.68342 4.61125 9.60684 4.62929 9.53316C4.64734 9.45947 4.68011 9.3902 4.72563 9.32951C4.77114 9.26881 4.82846 9.21795 4.89414 9.17999C4.95982 9.14202 5.03251 9.11773 5.10782 9.10859C5.18313 9.09944 5.25951 9.10562 5.33237 9.12676C5.40523 9.14789 5.47306 9.18355 5.53178 9.23158C5.5905 9.27961 5.6389 9.33903 5.67407 9.40625C6.1993 10.314 7.02477 10.8125 8 10.8125C8.97524 10.8125 9.80071 10.3133 10.3259 9.40625C10.3611 9.33903 10.4095 9.27961 10.4682 9.23158C10.5269 9.18355 10.5948 9.14789 10.6676 9.12676C10.7405 9.10562 10.8169 9.09944 10.8922 9.10859C10.9675 9.11773 11.0402 9.14202 11.1059 9.17999C11.1715 9.21795 11.2289 9.26881 11.2744 9.32951C11.3199 9.3902 11.3527 9.45947 11.3707 9.53316C11.3888 9.60684 11.3917 9.68342 11.3794 9.75828C11.3671 9.83313 11.3398 9.90473 11.2991 9.96875ZM10.5313 7.4375C10.3644 7.4375 10.2012 7.38802 10.0625 7.2953C9.92374 7.20259 9.81559 7.07081 9.75173 6.91664C9.68787 6.76246 9.67116 6.59281 9.70372 6.42914C9.73627 6.26547 9.81663 6.11513 9.93463 5.99713C10.0526 5.87913 10.203 5.79877 10.3666 5.76621C10.5303 5.73366 10.7 5.75037 10.8541 5.81423C11.0083 5.87809 11.1401 5.98623 11.2328 6.12499C11.3255 6.26374 11.375 6.42687 11.375 6.59375C11.375 6.81753 11.2861 7.03214 11.1279 7.19037C10.9696 7.34861 10.755 7.4375 10.5313 7.4375Z"
                                    fill="url(#paint0_linear_593_20883)"
                                 />
                                 <defs>
                                    <linearGradient
                                       id="paint0_linear_593_20883"
                                       x1="0.6875"
                                       y1="15.3125"
                                       x2="18.0272"
                                       y2="5.93409"
                                       gradientUnits="userSpaceOnUse">
                                       <stop stop-color="#98FF23" />
                                       <stop offset="1" stop-color="#27D089" />
                                    </linearGradient>
                                 </defs>
                              </svg>
                           </div>
                           <span className="ms-2 me-2 at-text-dark">15</span>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="p-2 mb-2">
                  <span className="video-name">Hello this videoo sdfh dsfjsfsdfdssdsdfdfdsfsf</span>
                  <p className="at-text-light v-chart-date">Sentiment 67</p>
               </div>
            </div> */}
         </div>
      </div>
   )
}

export default SentimentChart
